import {Component, computed, input} from '@angular/core';
import {PhaseStatusView, TenderPhaseType} from '@frontend/shared-api';
import {Card} from 'primeng/card';
import {IconButtonDialogComponent} from '../../../../../../shared/components/dialog/icon-button-dialog/icon-button-dialog.component';
import {TenderStatusUtils} from '../../../../../../phase/tender-status.util';

@Component({
  selector: 'app-tender-reason-text-button',
  imports: [Card, IconButtonDialogComponent],
  templateUrl: './tender-reason-text-button.component.html',
})
export class TenderReasonTextButtonComponent {
  readonly colorClass = input.required<string>();
  readonly phaseStatusInfo = input.required<PhaseStatusView>();

  protected readonly showReasonText = computed(() => {
    const phase = this.phaseStatusInfo().phase;
    return phase !== TenderPhaseType.RFI;
  });

  protected readonly hasReasonText = computed(() => {
    const status = this.phaseStatusInfo().status;
    return (
      TenderStatusUtils.canHaveDecisionReason(status) &&
      !!this.phaseStatusInfo().phaseDecisionReason
    );
  });

  protected readonly reasonIcon = computed(() => {
    const status = this.phaseStatusInfo().status;
    return TenderStatusUtils.isNegativeOutcome(status) ? 'pi pi-thumbs-down' : 'pi pi-thumbs-up';
  });
}
